<div *ngIf="isMobile">
    <app-otp-phone-selector-mobile></app-otp-phone-selector-mobile>
</div>

<div *ngIf="!isMobile">
    <app-otp-phone-selector-desktop></app-otp-phone-selector-desktop>
</div>
